import { render, staticRenderFns } from "./ownerForm.vue?vue&type=template&id=09d06a68&"
import script from "./ownerForm.vue?vue&type=script&lang=ts&"
export * from "./ownerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports